import React from 'react';

const FooterAccordionArrowIcon = () => {
  return (
    <div className={'arrow'}>
      <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5286 4.47136C3.78895 4.73171 4.21106 4.73171 4.47141 4.47136L7.80474 1.13803C8.06509 0.877681 8.06509 0.455571 7.80474 0.195221C7.54439 -0.0651278 7.12228 -0.0651278 6.86193 0.195221L4 3.05715L1.13807 0.195221C0.877722 -0.0651278 0.455612 -0.0651278 0.195262 0.195221C-0.0650874 0.455571 -0.0650874 0.877681 0.195262 1.13803L3.5286 4.47136Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default FooterAccordionArrowIcon;